import { gql } from '@apollo/client';

export const GET_MY_DISTRICT = gql`
  query getMyDistrict {
    getMyDistrict {
      districtId
      name
      isMultiDistrict
      treeCounter
      sheetCounter
      branding {
        logoAlt
        logoLinkUrl
        logoUrl
      }
      communitySettings {
        flyerDisclaimer
        guidelinesUrl
      }
    }
  }
`;
